import { DataTableAdapter } from "../../../adapters/datatable.adapter";
import { ViewButton } from "../../../models/view-config/view-button.model";
import { ViewColumnField } from "../../../models/view-config/view-column-field.model";
import { ViewImageButton } from "../../../models/view-config/view-image-button.model";
import { ApiService } from "../../../services";
import { UscStoreService } from "../../../services/usc-store/usc-store.service";
import { DialogComponent } from "../../common/dialog/dialog.component";
import { UscDialogComponent } from "../usc-dialog/usc-dialog.component";
import { UscModalComponent } from "../usc-modal/usc-modal.component";
import { UscUserLookupComponent } from "../usc-user-lookup/usc-user-lookup.component";

export class UscUploadedDocumentDataTableAdapter extends DataTableAdapter {

    uscStoreService: UscStoreService;
    apiService: ApiService;
    is_national_retail_associate: boolean = false;
    is_not_national_retail_associate: boolean = true;

    constructor(view: string, serviceCollection: any, store_team_ID: string) {
        super(view, serviceCollection);
        if (serviceCollection['uscStoreService']) this.uscStoreService = serviceCollection['uscStoreService'];
    }

    public initialize(): void {
        super.initialize();

        var current_view = this.uscStoreService.view_uploaded_documents;
        this.is_national_retail_associate = this.uscStoreService.getItemCustomFieldValue(this.current_user, "National Retail Associate") == 'Yes';
        this.is_not_national_retail_associate = this.uscStoreService.getItemCustomFieldValue(this.current_user, "National Retail Associate") != 'Yes';
    }

    public getDetailItems(init_filter_fields: boolean): any {
        var params = this.getSearchParams(this.getExecuteScriptType(true, false), this.getCurrentServerSideFilters());
        var dlg = this.dialogService.showLoadingDlg(DialogComponent, { msg: "Loading..." });
        this.uscStoreService.getData(this.datatable_view, params).subscribe(
            result => {
                this.data_items = result.items;
                this.processDataItems(this.data_items, init_filter_fields);
                this.is_loading_data = false;
                dlg.dismiss();

                // get total count of data
                var params = this.getSearchParams(this.getExecuteScriptType(false, true));
                this.uscStoreService.getData(this.datatable_view, params).subscribe(
                    result => {
                        this.itemCount = result.total_count;
                        this.pageCount = Math.ceil(this.itemCount / this.pageSize);
                        console.log(this.pageCount);
                        console.log(this.itemCount);
                        console.log(this.pageSize);
                    },
                    err => {
                        console.log(err);
                    }
                );
            },
            err => {
                console.log(err);
            }
        );
    }

    getFieldValueStyle(data_item: any, field: ViewColumnField) {
        var fvc = {};
        //add highlight to the whole row
        switch (data_item.cfd_upload_status) {
            case 'In Progress':
            case 'Failed to Upload':
                fvc["background-color"] = "pink"; 
                break;
            case 'Uploaded – Offline Processing Required':
            case 'Uploaded - Offline Processing Required':
                fvc["background-color"] = "#ffffbf"; 
                break;
        }
        return fvc;
    }

    public getFieldValue(data_item: any, field: ViewColumnField): any {
        if (data_item && field) {
            var field_value = data_item[field.key];
            if (field.sn_calc_formula) {
                var sn_calc_formula = this.translatorService.translate(null, data_item, field.sn_calc_formula);
                if (sn_calc_formula) {
                    var formula_results = data_item.formula_results;
                    if (field.sn_calc_formula_frequency > 0) {
                        formula_results = this.formulaService.calculateFormulaValuesByItem(this.table_view_config.view_formulas, data_item);
                    }
                    var fr = formula_results.find(f => f.name == sn_calc_formula);
                    field_value = fr.result;
                }
            }

            var isNotScheduledAppt = data_item.me_sub_type == 'Bill Payment' || data_item.me_sub_type == 'Sales Associate';
            switch (field.key) {
                case 'dn_datetime_created': field_value = this.calendarService.getDateText(new Date(Date.parse(field_value)), 'yyyy-MM-dd hh:mm tt'); break;
                case 'cfd_approval_requested_on': if (field_value && field_value.length > 0) field_value = this.calendarService.getDateText(new Date(Date.parse(field_value)), 'yyyy-MM-dd hh:mm tt'); break;
                case 'cfd_doc_national_store_number': field_value = field_value != null ? field_value : 'N/A'; break;
            }

            return field_value != null ? field_value : '';
        }
        return null;
    }

    formatContactNumber(phone: string) {
        var formatted = "";
        if (phone && phone.length == 10) {
            formatted = phone.substring(0, 3) + '-' + phone.substring(3, 6) + '-' + phone.substring(6, 10);
        }
        return formatted;
    }

    protected processActionOnViewItem(btn: ViewButton, item: any, field: ViewColumnField, params: any) {
        var img_btn = btn as ViewImageButton;
        var loading_message = img_btn.action_loading_message ? img_btn.action_loading_message : "Updating Document...";
        var dlg = this.dialogService.showLoadingDlg(DialogComponent, { msg: loading_message });
        this.uscStoreService.processActionOnViewItem(this.datatable_view, item.view_ID, img_btn.action, params).subscribe(
            result => {
                dlg.dismiss();
                if (btn.reload_post_action) this.reloadItems();
            }, error => {
                this.sessionService.log('sn_view_action::' + img_btn.action + ' failed');
                dlg.dismiss();
            }
        )
    }


    public onBtnClick(btn: ViewButton, item: any, field: ViewColumnField) {
        console.log("onBtnClick::" + btn.event);
        var img_btn = btn as ViewImageButton;
        switch (btn.event) {
            case "sn_view_action": 
                if (img_btn.action == 'action_usc_document_rejected') {
                    const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
                    modalRef.componentInstance.parentView = this.datatable_view;
                    modalRef.componentInstance.data = item;
                    modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_doc_approval_reject_comment;
                    modalRef.result.then(
                        (result) => { 
                            var params = { rejection: result.rejection };
                            this.processActionOnViewItem(img_btn, item, field, params); 
                        },
                        (reason) => { }
                    );
                } else {
                    this.processActionOnViewItem(img_btn, item, field, null);
                }
                break;
        }
    }

    public isPagingEnabled(): boolean {
        return true;
    }

    public getNoDataMessage(): string {
        return "No Document Found";
    }

    public previousPage(): number {
        this.curPage = this.curPage - 1;
        this.reloadItems();
        return this.curPage;
    }

    public nextPage(): number {
        this.curPage = this.curPage + 1;
        this.reloadItems();
        return this.curPage;
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-uploaded-documents/usc-uploaded-document-dt-adapter.ts